import { packageService } from "@/api/packageService";
import type { CampaignCouponWithId } from "@/resources/coupon";
import type {
  CampaignResults,
  CampaignResultsRow,
  PackageWithId,
} from "@/resources/package";
import type { ScenarioWithId } from "@/resources/scenario";
import {
  checkScenarioShouldAssess,
  transformCampaignResult,
} from "./transformCampaignResult";

export async function getProcessedPackageResults(
  packageData: PackageWithId,
  scenarioList: ScenarioWithId[],
): Promise<CampaignResults[]> {
  try {
    if (!packageData) {
      return [];
    }

    const packageCampaignData = await packageService.getPackageCampaignData(
      packageData.id,
    );
    if (!packageCampaignData) {
      return [];
    }

    const campaignResults: CampaignResults[] = [];

    packageCampaignData.campaignData.forEach((campaignData) => {
      const campaignId = campaignData.campaign.id;
      const campaignCodeName = `${campaignData.campaign.campaignCode} (${campaignData.campaign.name})`;
      const campaign = campaignData.campaign;
      const coupons = campaignData.campaignResults
        .map((campaignResult) => campaignResult.coupon)
        .filter(Boolean) as CampaignCouponWithId[];
      const scenarioShouldAssess = checkScenarioShouldAssess(
        campaign,
        scenarioList,
      );
      const rows = campaignData.campaignResults
        .map((campaignResult) =>
          transformCampaignResult(
            campaignResult,
            campaign,
            scenarioShouldAssess,
          ),
        )
        .filter((rows): rows is CampaignResultsRow[] => rows !== null)
        .flat();
      const unregisteredCoupons = coupons.filter((coupon) => {
        return !coupon.isConfirmed && !coupon.learnerId;
      }).length;
      const incompleteTickets = campaignData.campaignResults
        .map((result) => result.ticket)
        .filter((ticket) => {
          if (!ticket) return false;
          return ticket.customerOptions.isAvailable;
        }).length;
      const completeTickets = campaignData.campaignResults
        .map((result) => result.ticket)
        .filter((ticket) => {
          if (!ticket) return false;
          return !ticket.customerOptions.isAvailable;
        }).length;

      campaignResults.push({
        campaignId,
        campaignCodeName,
        campaign,
        coupons,
        scenarioShouldAssess,
        unregisteredCoupons,
        incompleteTickets,
        completeTickets,
        rows,
      });
    });

    return campaignResults;
  } catch (error) {
    console.error("Error in getProcessedPackageResults:", error);
    return [];
  }
}
